import React from "react"
import icon from "images/layout/chevron-up.svg"

export default function ChevronUpIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
